import { AlertTriangle, Container, Pencil, Plus } from 'lucide-react';
import ExpiryBadge from './ExpiryBadge';
import { daysUntil } from './complianceUtils';

function StatusBadge({ status }) {
  const colors = {
    Available: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25',
    Engaged: 'bg-logi-accent/10 text-logi-accent ring-violet-500/25',
  };
  return (
    <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ring-1 ${colors[status] || colors.Available}`}>
      {status}
    </span>
  );
}

export default function AttachmentRegistryPanel({ attachments, onAdd, onEdit }) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Container className="h-4 w-4 text-logi-accent" />
          <h3 className="text-sm font-bold text-logi-text">Attachments Registry ({attachments.length})</h3>
        </div>
        <button type="button" onClick={onAdd} className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-violet-600 to-violet-500 px-4 py-2.5 text-sm font-bold text-white shadow-lg shadow-violet-500/20">
          <Plus className="h-4 w-4" />
          Add New Trailer / Tanker
        </button>
      </div>

      <div className="overflow-hidden rounded-xl border border-logi-grid bg-white">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[880px] text-left text-sm">
            <thead>
              <tr className="border-b border-logi-grid/80 bg-white text-[10px] uppercase tracking-wider text-logi-text0">
                <th className="px-3 py-2.5 font-semibold">Unit</th>
                <th className="px-3 py-2.5 font-semibold">Type</th>
                <th className="px-3 py-2.5 font-semibold">Trailer Mulkiya</th>
                <th className="px-3 py-2.5 font-semibold">Civil Defense</th>
                <th className="px-3 py-2.5 font-semibold">Status</th>
                <th className="px-3 py-2.5 font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-logi-grid/30">
              {attachments.map((a) => {
                const mulkiyaAlert = daysUntil(a.trailerMulkiyaExpiry) <= 30;
                return (
                  <tr key={a.id} className="hover:bg-logi-silver">
                    <td className="px-3 py-2.5">
                      <div className="flex items-center gap-2">
                        {a.unitPhoto?.previewUrl ? (
                          <img src={a.unitPhoto.previewUrl} alt="" className="h-8 w-8 rounded-md object-cover ring-1 ring-logi-grid" />
                        ) : (
                          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-white text-logi-text0"><Container className="h-4 w-4" /></span>
                        )}
                        <div>
                          <p className="font-semibold text-violet-300">{a.serialRegistrationNo}</p>
                          <p className="font-mono text-[10px] text-logi-text0">{a.id}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-2.5">
                      <p className="text-xs text-logi-muted">{a.type}</p>
                      <div className="mt-0.5 flex flex-wrap gap-1">
                        {a.capacityLitres && (
                          <span className="rounded bg-white px-1.5 py-0.5 font-mono text-[9px] text-logi-text0">
                            {a.capacityLitres.toLocaleString()}L
                          </span>
                        )}
                        {a.adrCertified && (
                          <span className="rounded bg-emerald-50 px-1.5 py-0.5 text-[9px] font-bold text-emerald-700 ring-1 ring-emerald-500/20">
                            ADR
                          </span>
                        )}
                        {a.isoSlots && (
                          <span className="rounded bg-logi-accent/10 px-1.5 py-0.5 text-[9px] font-bold text-logi-accent">
                            {a.isoSlots}-Slot ISO
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 py-2.5">
                      <div className="flex items-center gap-1">
                        <ExpiryBadge dateStr={a.trailerMulkiyaExpiry} compact />
                        {mulkiyaAlert && <AlertTriangle className="h-3 w-3 text-red-700" />}
                      </div>
                    </td>
                    <td className="px-3 py-2.5"><ExpiryBadge dateStr={a.civilDefensePermitExpiry} compact /></td>
                    <td className="px-3 py-2.5"><StatusBadge status={a.status} /></td>
                    <td className="px-3 py-2.5">
                      <button type="button" onClick={() => onEdit(a)} className="inline-flex items-center gap-1 rounded-lg border border-logi-grid px-2 py-1 text-[10px] font-bold uppercase text-logi-muted hover:border-violet-500/40 hover:text-violet-300">
                        <Pencil className="h-3 w-3" /> Edit
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
